<template>
  <v-btn @click="dialogOpen()" class="btnColorWhite">사원 업로드</v-btn>
  <v-dialog v-model="dialog"  width="660px" class="fontNotoSans400">
    <v-card>
      <v-card-text>
            <div v-if="loading" class="spinner tac"></div>
            <v-data-table no-data-text="데이터가 존재하지 않습니다." v-else fixed-header density="compact" scrollable :headers="headersArr" :items="empList"
              item-value="name" class="SsTb fontNotoSans400" style="
                height: calc(100vh - 200px); 
                max-height: 600px;
                overflow-y: hidden; 
                position: relative;
              " :items-per-page="-1" :items-per-page-options="[
                { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
              ]">
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title class="fontNotoSans700" style="max-width: 120px;">
                    <v-btn v-if="(selectEmp.length !== empList.length)" @click="allSelectEmp" class="btnColorWhite"
                      style="width: 100px;">전체체크</v-btn>
                    <v-btn v-else-if="(selectEmp.length === empList.length) && empList.length" @click="allSelectEmp"
                      class="btnColorWhite" style="width: 100px;">전체체크해제</v-btn>
                  </v-toolbar-title>
                  <div v-if="empList.length > 0">
                    <p>{{ formatYm(store.state.AdminYYMM) }} 계약 기간은 맞으나, 임금기초 리스트에</p>
                    <p>업로드되지 않은 사원입니다.</p>
                  </div>
                  <div v-else>
                    <p>{{ formatYm(store.state.AdminYYMM) }} 임금기초 리스트에</p>
                    <p>모든 사원이 업로드된 상태입니다.</p>
                  </div>
                </v-toolbar>
              </template>
              <template v-slot:item="{ item, index }">
                <tr class="SsTbTr">
                  <td class="tal" style="display: flex; justify-content: left; align-items: center;">
                    <v-checkbox style="display: inline-block;" v-model="selectEmp" :value="item" color="secondary"
                      hide-details></v-checkbox>
                    <span>{{ index + 1 }}.</span>
                  </td>
                  <td class="tac">{{ item.empNum }}</td>
                  <td class="tac">{{ item.empName }}</td>
                  <td class="tac">{{ item.empJob }}</td>
                                    <td class="tac">{{ item.empInDate || ''}}</td>
                  <td class="tac">{{ item.empOutDate || ''}}</td>
                </tr>
              </template>
            </v-data-table>
            <v-btn style="width: 100%;" class="btnColorUpdate mb-1" @click="saveGetNowEmpList()">사원 업로드</v-btn>
            <v-btn style="width: 100%;" class="btnColorDark" @click="notSelectEmp()">취소</v-btn>
      </v-card-text>
    </v-card>

  </v-dialog>
</template>
<script setup lang="ts">
import store from '@/store';
import axios from 'axios';
import { ref } from 'vue';
const dialog = ref(false);

// eslint-disable-next-line
const code = ref(store.state.AdminSisulCode) as any;

// eslint-disable-next-line
const emit = defineEmits(['success'])
const loading = ref(false);
// eslint-disable-next-line
const empList = ref([] as any[]);

const selectEmp = ref<string[]>([]);
const selectOutEmp = ref<string[]>([]);
// eslint-disable-next-line
const formatYm = (value: any) => {
  if (!value) return '';
  const [year, month] = value.split('-');
  return `${year}년 ${month}월`;
}
const dialogOpen = async () => {
  dialog.value = true;
  selectEmp.value = [];
  selectOutEmp.value = [];
  await getNowEmpList();
}
const headersArr = ref([
  { title: 'No.', key: 'index', align: 'center', sortable: false },
  { title: '사원번호', key: 'empNum', align: 'center', sortable: true },
  { title: '이름', key: 'empName', align: 'center', sortable: true },
  { title: '직위', key: 'empJob', align: 'center', sortable: true },
  { title: '입사일', key: 'empInDate', align: 'center', sortable: true },
    { title: '퇴사일', key: 'empOutDate', align: 'center', sortable: true },
  
// eslint-disable-next-line
] as any[]);
const allSelectEmp = () => {
  if (selectEmp.value.length === empList.value.length) {
    selectEmp.value = [];
  } else {
    selectEmp.value = empList.value;
  }
};
const notSelectEmp = () => {
  dialog.value = false;
};

const saveGetNowEmpList = async () => {
  if (loading.value) return;
  if (selectEmp.value.length === 0) {
    alert('불러올 사원정보를 선택해주세요.')
    return;
  }
  const isConfirmed = window.confirm('사원을 업로드하시겠습니까?');
  if (isConfirmed) {
    loading.value = true;
    const insertDate = store.state.AdminYYMM;
    try {
      const response = await axios.post(`/api/saveGetNowEmpList/${insertDate}/${code.value}`, { form: selectEmp.value });
      const result = response.data;
      if (result.success === true) {
        emit('success');
        dialog.value = false;
      } else {
        alert('사원 업로드에 실패하였습니다. 관리자에게 문의해주세요.');
      }
    } catch (error) {
      alert('사원 업로드를 처리할 수 없습니다.');
      console.error(error);
    } finally {
      loading.value = false;
    }
  } else {
    return;
  }
};

const getNowEmpList = async () => {
  if (loading.value) return;
  loading.value = true;
  try {
    const response = await axios.get(`/api/getNowEmpList/${code.value}/${store.state.AdminYYMM}`);
    const responseData = response.data;
    if (responseData) {
      empList.value = responseData;
      return responseData;
    } else {
      console.error('에러가 발생했습니다.');
    }
  } catch (error) {
    console.error('errorMsg:', error);
  } finally {
    loading.value = false;
  }
};

</script>

<style scoped>
.monthLabelBtn {
  background-color: #fff;
  color: #333;
  border: 1px solid rgb(203, 203, 203);
  font-size: 16px;
  min-width: 50px !important;
  max-height: 40px !important;
}

.btnBg {
  background: linear-gradient(45deg, #e89e7e, #ff9b70);
  color: #fff !important;
}

</style>